// import { Heading,Center,Button } from "@chakra-ui/react"

function Header() {
    return (
        <div className="Hero-container">

     
            <h1>The Ultimate Online Resource for Everyday use.</h1>
     
            <p>Found us usefull? Please upvote us on ProductHunt.</p>
            <br />
           
            <a href="#" >Button</a>
           
           
        </div>
    )
}

export default Header
